import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import TerraSyncButton from '@components/TerraSyncButton';

import { useGetLatestObservations } from '@hooks/api/observation';

import Body from '../Body';
import Fitness from '../Fitness';
import Sleep from '../Sleep';
import VitalSign from '../VitalSign';

function Metrics() {
  const {
    data: {
      // Body
      blood_sugar,
      body_height,
      body_weight,
      body_mass_index,
      muscle_mass,
      // Vital sign
      heart_rate,
      temperature,
      blood_pressure,
      respiration,
      oxygen_saturation,
      pain,
      hrv,
      // stress_index,
      // Fitness
      distance,
      steps,
      fitness_average_heart_rate,
      resting_heart_rate,
      energy_burned,
      // Sleep
      sleep_average_heart_rate,
      sleep_duration,
      sleep_score,
    },
    loading,
  } = useGetLatestObservations({
    // Body
    blood_sugar: true,
    body_height: true,
    body_weight: true,
    body_mass_index: true,
    muscle_mass: true,
    body_fat_percentage: true,
    body_chest_cm: true,
    body_waist_cm: true,
    body_hips_cm: true,
    body_thigh_cm: true,
    body_waist_hip: true,
    body_waist_height: true,
    // Vital sign
    heart_rate: true,
    temperature: true,
    blood_pressure: true,
    respiration: true,
    oxygen_saturation: true,
    pain: true,
    hrv: true,
    // stress_index: true,
    // Fitness
    distance: true,
    steps: true,
    fitness_average_heart_rate: true,
    resting_heart_rate: true,
    energy_burned: true,
    // Sleep
    sleep_duration: true,
    sleep_score: true,
    sleep_average_heart_rate: true,
  });

  const bodyRecords = {
    blood_sugar,
    body_height,
    body_weight,
    body_mass_index,
    muscle_mass,
  };
  const vitalSignRecords = {
    heart_rate,
    temperature,
    blood_pressure,
    respiration,
    oxygen_saturation,
    pain,
    hrv,
    // stress_index
  };
  const fitnessRecords = {
    distance,
    steps,
    average_heart_rate: fitness_average_heart_rate,
    resting_heart_rate,
    energy_burned,
  };
  const sleepRecords = {
    sleep_duration,
    sleep_score,
    average_heart_rate: sleep_average_heart_rate,
  };

  return (
    <>
      <Body loading={loading} observations={bodyRecords} />
      <VitalSign loading={loading} observations={vitalSignRecords} />
      <Fitness loading={loading} observations={fitnessRecords} />
      <Sleep loading={loading} observations={sleepRecords} />
      <TerraSyncButton />
    </>
  );
}

export default withErrorBoundary(Metrics, {
  fallback: null,
});
